import React from 'react';
import PropTypes from 'prop-types';
import { Tab, mergeClasses } from '@fluentui/react-components';

export const CustomTab = ({
  value,
  classes,
  isSelected,
  children,
}) => (
  <div className={mergeClasses('tab-item', classes.tabItemWrapper, isSelected && 'selected selected-sub-folder')}>
    <Tab
      value={value}
    >
      {children}
    </Tab>
  </div>
);

CustomTab.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  classes: PropTypes.shape({
    tabItemWrapper: PropTypes.string,
    selected: PropTypes.string,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};
